import { render, staticRenderFns } from "./NavContent.vue?vue&type=template&id=2d891a06&scoped=true&"
import script from "./NavContent.vue?vue&type=script&lang=js&"
export * from "./NavContent.vue?vue&type=script&lang=js&"
import style0 from "./NavContent.vue?vue&type=style&index=0&id=2d891a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d891a06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Nav: require('/opt/build/repo/components/Nav.vue').default,Footer: require('/opt/build/repo/components/Footer.vue').default})
